// extracted by mini-css-extract-plugin
export var category__container = "Category-module--category__container--4fe2a";
export var category__img = "Category-module--category__img--a6972";
export var container_title = "Category-module--container_title--d3500";
export var link = "Category-module--link--e5d74";